var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalisticIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 20,
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 3H8.00002V12H5V15H3V12H0V3H3V0H5V3ZM2 5V9.99997H6V5H2ZM15 7.99997H18V17H15V20H13V17H10V7.99997H13V5H15V7.99997ZM12 9.99997V15H16V9.99997H12Z",
  fill: "#D44500"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalisticIcon);
export { ForwardRef as ReactComponent };